import {
  BroadcastEventType,
  BroadcastIngestFields,
  BroadcastRtmpSettingsFields,
  TeamsLiveEventType,
} from '@ms/yammer-graphql';

import { Entity, LiveEventStatusInformation, Network, User } from '../types';

type Guid = string;

export type LiveEventWithStatus = LiveEvent & LiveEventStatusInformation;

export interface LiveEvent extends Entity {
  readonly broadcastId: Guid;
  readonly editLink: string;
  readonly endAt: number;
  readonly eventType: BroadcastEventType;
  readonly id: string;
  readonly isEmbeddable: boolean;
  readonly isPublished: boolean;
  readonly joinLink: string;
  readonly networkId: Network['id'];
  readonly organizerId: User['id'];
  readonly presenterIds: User['id'][];
  readonly producerIds: User['id'][];
  readonly startAt: number;
  readonly title: string;
  readonly description?: string;
  readonly ingest?: BroadcastIngestFields;
  readonly metricsLink?: string;
  readonly productionEmbedUrl?: string;
  readonly streamLink?: string;
  readonly isDiscoverable: boolean;
  readonly isGroupCalendarInviteSent: boolean;
  readonly isThreadStarterRestricted: boolean;
  readonly isThreadStarterAdminModerated: boolean;
  readonly isReplyToConversationEnabled: boolean;
  readonly canStartThread: boolean;
  readonly realtimeChannelId: string;
  readonly createdAt: number;
  readonly teamsLiveEventType?: TeamsLiveEventType;
  readonly calendarDownloadUrl?: string;
  readonly icsBlobLink?: string;
  readonly teamsJoinLink?: string;
  readonly rtmpSettings?: BroadcastRtmpSettingsFields;
}

export type LiveEvents = Record<LiveEvent['broadcastId'], LiveEvent>;
export { BroadcastIngestUrlFields } from '@ms/yammer-graphql';

export interface EventEdge {
  readonly cursor: string;
  readonly broadcastId: LiveEvent['broadcastId'];
}

export enum UserEventPermissions {
  None = 'None',
  QuickstartProducible = 'QuickstartProducible',
  QuickstartPresentable = 'QuickstartPresentable',
  BYOEProducible = 'ByoeProducible',
  TeamsProducible = 'TeamsProducible',
  TeamsPresentable = 'TeamsPresentable',
  TeamsBYOEProducible = 'TeamsBYOEProducible',
  TeamsBYOEPresentable = 'TeamsBYOEPresentable',
}

export enum LiveEventPlayerType {
  Stream = 'Stream',
  Teams = 'Teams',
}

export type LiveEventProductionType = BroadcastEventType | TeamsLiveEventType;
